<script lang="ts">import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import VipEventCard from "./vip-event-card.svelte";
import VipTitle from "./vip-title.svelte";
export const eventKeys = [
	{
		titleKey: "join_us_at_the_merit",
		descriptionKey: "join_us_at_the_merit_description",
		image: cfgToThemeCdnPath("/about-vip/event-1.png")
	},
	{
		titleKey: "padel_masters_2026",
		descriptionKey: "padel_masters_2026_description",
		image: cfgToThemeCdnPath("/about-vip/event-2.png")
	},
	{
		titleKey: "monaco_vip_hospitality",
		descriptionKey: "monaco_vip_hospitality_description",
		image: cfgToThemeCdnPath("/about-vip/event-3.png")
	},
	{
		titleKey: "magical_macau",
		descriptionKey: "magical_macau_description",
		image: cfgToThemeCdnPath("/about-vip/event-4.png")
	},
	{
		titleKey: "champions_league_final",
		descriptionKey: "champions_league_final_description",
		image: cfgToThemeCdnPath("/about-vip/event-5.png")
	},
	{
		titleKey: "rocketbet_vegas_takeover",
		descriptionKey: "rocketbet_vegas_takeover_description",
		image: cfgToThemeCdnPath("/about-vip/event-6.png")
	}
];
</script>

<div class="vip-events-container">
	<VipTitle title={$t(Verbiage.vip_events)} />
	<div class="vip-events">
		{#each eventKeys as event}
			<VipEventCard
				title={$t(Verbiage[event.titleKey])}
				description={$t(Verbiage[event.descriptionKey])}
				image={event.image}
			/>
		{/each}
	</div>
</div>

<style>
	.vip-events-container {

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 2rem
}

	.vip-events {

		display: flex;

		width: 100%;

		flex-wrap: wrap;

		gap: 0px
}

	@media (min-width: 1024px) {
		.vip-events {

				gap: 2%
		}
	}
</style>
